var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83325 13.125H1.83325C1.34927 13.125 0.958252 12.734 0.958252 12.25V1.75C0.958252 1.26602 1.34927 0.875 1.83325 0.875H5.33325V3.9375C5.33325 4.66211 5.92114 5.25 6.64575 5.25H9.70825V12.25C9.70825 12.734 9.31724 13.125 8.83325 13.125ZM6.64575 4.375C6.40513 4.375 6.20825 4.17812 6.20825 3.9375V0.888672C6.28481 0.907812 6.35591 0.946094 6.4106 1.00352L9.57974 4.17266C9.63716 4.23008 9.67544 4.29844 9.69458 4.375H6.64575ZM1.83325 0C0.868018 0 0.083252 0.784766 0.083252 1.75V12.25C0.083252 13.2152 0.868018 14 1.83325 14H8.83325C9.79849 14 10.5833 13.2152 10.5833 12.25V4.48164C10.5833 4.13437 10.4438 3.80078 10.1977 3.55469L7.0313 0.385547C6.78521 0.139453 6.45161 0 6.10435 0H1.83325ZM5.77075 7.61797L7.21177 9.05898C7.3813 9.22852 7.6602 9.22852 7.82974 9.05898C7.99927 8.88945 7.99927 8.61055 7.82974 8.44102L5.64224 6.25352C5.47271 6.08398 5.1938 6.08398 5.02427 6.25352L2.83677 8.44102C2.66724 8.61055 2.66724 8.88945 2.83677 9.05898C3.0063 9.22852 3.28521 9.22852 3.45474 9.05898L4.89575 7.61797V10.9375C4.89575 11.1781 5.09263 11.375 5.33325 11.375C5.57388 11.375 5.77075 11.1781 5.77075 10.9375V7.61797Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.10dc25635ac8e19319fec79ff1a110e6.svg";
export { ForwardRef as ReactComponent };